import { StepLogger } from "analytics/funnel";
import { History } from "history";
import L10n from "localization";
import GoalTestVectorNav from "./goalTestVectorNav";
import SingleSelectNav, { IPromptOption } from "./singleSelectNav";

interface IProps {
  dismiss: () => Promise<void>;
  onAddToInbox: () => void;
  history: History;
  logStep: StepLogger;
}
export default function GoalTestNav(props: IProps) {
  const opts: IPromptOption[] = [
    { name: "A Levels", val: "A Levels" },
    { name: "CCNA", val: "CCNA" },
    { name: "CFA", val: "CFA" },
    { name: "CONCURSO", val: "CONCURSO" },
    { name: "DAT", val: "DAT" },
    { name: "DSE", val: "DSE" },
    { name: "ENARM", val: "ENARM" },
    { name: "ENEM", val: "ENEM" },
    { name: "FUVEST", val: "FUVEST" },
    { name: "GCSE", val: "GCSE" },
    { name: "GMAT", val: "GMAT" },
    { name: "GRE", val: "GRE" },
    { name: "HSK", val: "HSK" },
    { name: "IELTS", val: "IELTS" },
    { name: "IGCSE", val: "IGCSE" },
    { name: "JLPT", val: "JLPT" },
    { name: "LSAT", val: "LSAT" },
    { name: "MCAT", val: "MCAT" },
    { name: "NCLEX", val: "NCLEX" },
    { name: "SAT", val: "SAT" },
    { name: "TOEFL", val: "TOEFL" },
    { name: "TOEIC", val: "TOEIC" },
    { name: "USMLE", val: "USMLE" },
    { name: "NEET", val: "NEET" }, // Indian medical exam
    { name: "NEET PG", val: "NEET PG" }, // Indian medical exam post-graduate
    { name: "MIR", val: "MIR" }, // Spanish medical residency exam
    { name: "ENARE", val: "ENARE" }, // Brazilian medical residency exam
    { name: "PNLE", val: "PNLE" }, // Phillipes nursing exam
    { name: "MSRA", val: "MSRA" }, // UK medical exam
    { name: "PTE", val: "PTE" }, // Pearson Test of English
  ].sort((o1, o2) => o1.name.localeCompare(o2.name));
  return (
    <SingleSelectNav
      title={L10n.localize((s) => s.onboarding.testNavTitle)}
      description={L10n.localize((s) => s.onboarding.testNavDescription)}
      options={opts}
      otherPrompt={L10n.localize((s) => s.onboarding.testNavDescription)}
      dismiss={props.dismiss}
      history={props.history}
      onNav={(opt) => {
        const test = opt.val;
        props.logStep("picked_test", { goal: "test", test });
        return (
          <GoalTestVectorNav
            dismiss={props.dismiss}
            history={props.history}
            onAddToInbox={props.onAddToInbox}
            logStep={props.logStep}
            test={test}
          />
        );
      }}
      searchable
    />
  );
}
